import React, { useEffect, useState } from 'react';
import Select, { MultiValue } from 'react-select';
import { FormikProps } from 'formik';
import './MultiSelectDropdown.scss';

interface MultiSelectDropdownProps {
    name: string;
    options: any[];
    formik: FormikProps<any>;
}

interface OptionType {
    label: string;
    value: string;
}

const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({
    name,
    options,
    formik,
}) => {
    const [defaultOptions, setDefaultOptions] = useState<OptionType[]>([]);

    useEffect(() => {
        const formatted = options?.map((opt) => ({
            label: opt.name,
            value: opt.value,
        }));
        setDefaultOptions(formatted);
    }, [options]);

    const handleChange = (
        selectedOptions: MultiValue<OptionType>,
    ) => {
        const formattedString = selectedOptions?.map((option) => option?.value).join(";");
        formik.setFieldValue(name, formattedString);
    };

    const parseValue = (): OptionType[] => {
      
        const valueString = formik.values[name];
        if (typeof valueString !== "string" || !valueString.trim()) return [];
        const selectedIds = valueString.split(";");
        return defaultOptions?.filter((opt) => selectedIds.includes(opt.value));
    };

    const customStyles = {
        control: (provided: any) => ({
            ...provided,
            minHeight: '44px',
            height: 'auto',
            flexWrap: 'wrap',
            overflowY: 'auto',
            maxHeight: '80px',
        }),
        placeholder: (provided: any) => ({
            ...provided,
            textAlign: 'left',
            marginLeft: '5px',
        }),
        menu: (provided: any) => ({
            ...provided,
            textAlign: 'left',
        }),
        option: (provided: any) => ({
            ...provided,
            textAlign: 'left',
            cursor: 'pointer',
        }),
        clearIndicator: (provided: any) => ({
            ...provided,
            cursor: 'pointer',
        }),
    };

    return (
        <div className="multi-select-wrapper">
            <label className="MultiSelectDropdown-label" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                Additional sales rep lead
                <Select
                    className='MultiSelectDropdown-container'
                    isMulti
                    name={name}
                    value={parseValue()}
                    onChange={handleChange}
                    options={defaultOptions}
                    styles={customStyles}
                    components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null
                    }}
                />
            </label>

        </div>
    );
};

export default MultiSelectDropdown;

